import { render, staticRenderFns } from "./CloneLesson.vue?vue&type=template&id=513dbc94&"
import script from "./CloneLesson.vue?vue&type=script&lang=js&"
export * from "./CloneLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports